import type { GetAccountSettingsResponse } from '@fourthwall/services/dist/MembershipsCreatorApiClient'

export enum FormFields {
  annualEnabled = 'annualEnabled',
  freeAccounts = 'freeAccounts',
  anualDiscount = 'anualDiscount',
  contentVisibility = 'contentVisibility',
  membersCountEnabled = 'membersCountEnabled',
  adultContent = 'adultContent',
  audioDownload = 'audioDownload',
  membershipsVisible = 'membershipsVisible',
  gifEnabled = 'gifEnabled',
}

export type FormValues = {
  [FormFields.annualEnabled]?: boolean
  [FormFields.freeAccounts]?: 'show' | 'hide'
  [FormFields.anualDiscount]?: string
  [FormFields.contentVisibility]: GetAccountSettingsResponse['tiers']['contentVisibility']
  [FormFields.membersCountEnabled]: GetAccountSettingsResponse['tiers']['membersCountEnabled']
  [FormFields.adultContent]: GetAccountSettingsResponse['adultContent']['present']
  [FormFields.audioDownload]: GetAccountSettingsResponse['mediaDownload']['audio']['enabled']
  [FormFields.membershipsVisible]: GetAccountSettingsResponse['membershipsVisibility']['public']
  [FormFields.gifEnabled]: GetAccountSettingsResponse['gifting']['enabled']
}
